/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_LANGUAGE_DETAILS_REQUEST,
  FETCH_LANGUAGE_DETAILS_SUCCESS,
  FETCH_LANGUAGE_DETAILS_FAILURE,
  FETCH_CURRENT_LANGUAGE_DETAILS,
} from "./LanguageDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchLanguageDetailsRequest = () => {
  return {
    type: FETCH_LANGUAGE_DETAILS_REQUEST,
  };
};

export const fetchLanguageDetailsSuccess = (languageData) => {
  return {
    type: FETCH_LANGUAGE_DETAILS_SUCCESS,
    payload: languageData,
  };
};

export const fetchLanguageDetailsFailure = (error) => {
  return {
    type: FETCH_LANGUAGE_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchCurrentLanguage=(currentLanguage)=>{
  return {
    type:FETCH_CURRENT_LANGUAGE_DETAILS,
    payload:currentLanguage
  }
}

export const fetchLanguageDetails = (defaultLanguage) => {
  return async function (dispatch) {
    dispatch(fetchLanguageDetailsRequest());
    try {
      const data = await APIManager.getLanguages(defaultLanguage);
      dispatch(fetchLanguageDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchLanguageDetailsFailure(error));
      dispatch(commonError(error, FETCH_LANGUAGE_DETAILS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
